/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InAppNotificationDto { 
    id: string;
    type: string;
    status: InAppNotificationDto.StatusEnum;
    createdAt: string;
    readAt?: string;
    data: any | null;
}
export namespace InAppNotificationDto {
    export const StatusEnum = {
        read: 'read',
        not_read: 'not-read'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


